
import {defineComponent} from "vue";
import {PropType} from "vue/dist/vue";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import ProductList from "@/components/UI/product/ProductList.vue";
import {ProductListSelectionDto} from "@/components/UI/product/ProductListSelectionDto";

export default defineComponent({
  name: "ProductFilterConditionProductList",
  components: {
    ProductList,
    BaseDeleteButton
  },
  emits: ['cnkCodesUpdated', 'productCodesUpdated', 'filterRemoved'],
  props: {
    cnkCodes: {
      type: Array as PropType<string[]>,
      required: true
    },
    productCodes: {
      type: Array as PropType<string[]>,
      required: true
    },
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: true
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localCnkCodes: [] as string[],
      localProductCodes: [] as string[]
    }
  },
  mounted() {
    this.syncFromProps();
  },
  watch: {
    cnkCodes() {
      this.syncFromProps();
    },
    productCodes() {
      this.syncFromProps();
    }
  },
  methods: {
    syncFromProps(): void {
      this.localCnkCodes = [...this.cnkCodes];
      this.localProductCodes = [...this.productCodes];
    },
    removeCondition(): void {
      this.$emit('filterRemoved');
    },
    updateProducts(value: ProductListSelectionDto): void {
      this.localCnkCodes = value.cnkCodes;
      this.localProductCodes = value.productCodes;
      this.$emit('cnkCodesUpdated', this.localCnkCodes);
      this.$emit('productCodesUpdated', this.localProductCodes);
    }
  },
  computed: {
    productSelection(): ProductListSelectionDto {
      return {
        cnkCodes: this.localCnkCodes,
        productCodes: this.localProductCodes
      };
    },
  }
});
